import { goRequest } from '../utils/httpClientTs';

export const getChapters = (data) => {
  let url = '/api/chapters';
  if (data.spd_id) {
    url += `?spd_id=${data.spd_id}`;
  }
  if (data.all) {
    if (data.spd_id) {
      url += `&all=true`;
    } else {
      url += `?all=true`;
    }
  }
  return goRequest({
    url: url,
    method: 'GET',
  });
};

export const getSpds = (data) => {
  let url = `/api/spds?all=${data.all}`;
  if (data.reportId) {
    url += `&report_id=${encodeURIComponent(data.reportId)}`;
  }
  return goRequest({
    url,
    method: 'GET',
  });
};
